import { render, staticRenderFns } from "./cardChannelsDiff.vue?vue&type=template&id=287c471f"
import script from "./cardChannelsDiff.vue?vue&type=script&lang=js"
export * from "./cardChannelsDiff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports